import { Layout } from "~/components/Layout";
import {
  SubCheckoutPageV2,
  SubCheckoutPageV2Props,
} from "~/components/SubCheckoutV2/SubCheckoutPage";
import { NextPageWithLayout } from "~/types/endil/NextPageWithLayout";

export type SubCheckoutServerProps = Omit<
  SubCheckoutPageV2Props,
  // these properties are only used for testing and can be ignored
  "autoUpdateUserState" | "defaultAccountStep"
>;

export const SubscriptionCheckoutNextPage: NextPageWithLayout<
  SubCheckoutServerProps
> = (props) => <SubCheckoutPageV2 {...props} />;

SubscriptionCheckoutNextPage.getLayout = (component) => (
  <Layout parentLayout="contents">{component}</Layout>
);
